import { QueryResult, useQuery } from '@apollo/client';
import { BookReadingData } from '@lwtears/lwt-common-frontend/lib/types';
import { GET_READ_ALOUD_STUDENT, GET_READ_ALOUD_EDUCATOR } from '../../../graph/queries/readAloud';
import { Asset } from '../../../graph/schema-generated-types-educator';
import { BookParams } from '../../../types';
import { isStudentApp } from '../../../util/app-util';

const useReadAloudStore = (bookParams: BookParams): [BookReadingData] => {
  const query = isStudentApp ? GET_READ_ALOUD_STUDENT : GET_READ_ALOUD_EDUCATOR;
  const {
    data,
    loading,
    error,
  }: QueryResult<{ readAloud: { book: any; pages: any[]; instructions: Asset } }> = useQuery(
    query,
    {
      variables: {
        readActivityWhere: {
          book: {
            bookCode: bookParams.bookCode,
            type: bookParams.bookType,
            edition: 2022,
            character: { character: bookParams.letter },
          },
        },
      },
    }
  );
  const { book = null, pages = null, instructions = null } = data?.readAloud ?? {};

  return [
    {
      book,
      pages,
      instructions,
      error,
      loading,
    },
  ];
};

export default useReadAloudStore;
